/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
/* eslint-enable no-restricted-imports */
import useSWR from "swr";
import { fetchFirestoreCollectionBySnapshot } from "utility/firebase";

import type { Category } from "@spwn/types/firebase/firestore";

export const useGetContactCategoryList = () => {
  return useSWR("contact/categories", async () => fetchContactCategoryList(), {
    revalidateOnFocus: false,
  });
};

const fetchContactCategoryList = async () => {
  const snapshot = firebase
    .firestore()
    .collection("/FAQ/public/categories")
    .where("isReleased", "==", true)
    .get();
  return await fetchFirestoreCollectionBySnapshot<Category>(snapshot);
};
